import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';

import { BaseField, DollarField } from '../../fields';
import { toDollarFormat } from '../../../utils';
import { setUserBonusMonthId } from '../actions';
import { getUserBonusMonthId } from '../selectors';
import { FINALIZED } from '../constants';

const propTypes = exact({
  memberPath: PropTypes.string.isRequired,

  totalBillingHours: PropTypes.number.isRequired,
  totalBillingRevenue: PropTypes.number.isRequired,
  totalBonusOpportunity: PropTypes.number.isRequired,
  districtName: PropTypes.string.isRequired,
  departmentName: PropTypes.string.isRequired,

  setUserBonusMonthIdAction: PropTypes.func.isRequired,
  userBonusMonthId: PropTypes.number.isRequired,
  currentUserBonusMonthId: PropTypes.number.isRequired,
  isUserActive: PropTypes.bool.isRequired,
  currentState: PropTypes.string.isRequired,
  totalPerDiemAmount: PropTypes.number.isRequired,
});

const selector = formValueSelector('userTicketBonusForm');

const UserMonthBonusField = (props) => {
  const {
    memberPath,
    totalBillingHours,
    totalBillingRevenue,
    totalBonusOpportunity,
    districtName,
    departmentName,
    userBonusMonthId,
    currentUserBonusMonthId,
    isUserActive,
    currentState,
    totalPerDiemAmount,
  } = props;

  const { setUserBonusMonthIdAction } = props;

  const isActive = (userBonusMonthId === currentUserBonusMonthId)
    ? { backgroundColor: '#337ab7', color: '#fff', cursor: 'pointer' }
    : { cursor: 'pointer' };

  const handleSelectUserBonusMonthId = (selectedId) => {
    setUserBonusMonthIdAction(selectedId);
  };

  const isDisabled = (!isUserActive || currentState === FINALIZED);
  return (
    <tr
      style={isActive}
      onClick={() => { return handleSelectUserBonusMonthId(userBonusMonthId); }}
    >
      <td>
        {districtName}
      </td>
      <td>{departmentName} </td>
      <td>
        {totalBillingHours}
      </td>
      <td>
        {toDollarFormat(totalBillingRevenue)}
      </td>
      <td>
        {toDollarFormat(totalBonusOpportunity)}
      </td>
      <td>
        {toDollarFormat(totalPerDiemAmount)}
      </td>
      <td>
        <DollarField
          name={`${memberPath}.approved_bonus_amount`}
          label={null}
          componentProps={{ disabled: (isDisabled) ? 'disabled' : '' }}
        />
      </td>
      <td>
        <BaseField
          name={`${memberPath}.manager_notes`}
          label={null}
          componentProps={{ disabled: (isDisabled) ? 'disabled' : '' }}
        />
      </td>
    </tr>
  );
};


UserMonthBonusField.propTypes = propTypes;

const mapDispatchToProps = {
  setUserBonusMonthIdAction: setUserBonusMonthId,
};

const enhance = connect((state, ownProps) => {
  const totalBillingHours = selector(state, `${ownProps.memberPath}.total_billing_hours`);
  const totalBillingRevenue = selector(state, `${ownProps.memberPath}.total_billing_revenue`);
  const totalBonusOpportunity = selector(state, `${ownProps.memberPath}.total_bonus_opportunity`);

  const districtName = selector(state, `${ownProps.memberPath}.district.name`);
  const departmentName = selector(state, `${ownProps.memberPath}.department.name`);
  const userBonusMonthId = selector(state, `${ownProps.memberPath}.id`);

  const currentUserBonusMonthId = getUserBonusMonthId(state);
  const isUserActive = selector(state, `${ownProps.memberPath}.user.active`);
  const currentState = selector(state, `${ownProps.memberPath}.state`);

  const totalPerDiemAmount = selector(state, `${ownProps.memberPath}.total_per_diem_amount`);

  return {
    totalBillingHours,
    totalBillingRevenue,
    totalBonusOpportunity,
    districtName,
    departmentName,
    userBonusMonthId,
    currentUserBonusMonthId,
    isUserActive,
    currentState,
    totalPerDiemAmount,
  };
}, mapDispatchToProps);

export default enhance(UserMonthBonusField);
